const SkillsInfo = [
    {
        id: 1,
        type: 'web',
        name1: 'React.JS',
        name2: 'Node.JS',
        name3: 'Express.JS',
        name4: 'Next.JS',
        name5: 'MongoDB',
        name6: 'Bootstrap',
        percent1: 90,
        percent2: 60,
        percent3: 60,
        percent4: 10,
        percent5: 70,
        percent6: 90,
    },
    {
        id: 2,
        type: 'programming',
        name1: 'JavaScript',
        name2: 'C',
        name3: 'C++',
        name4: 'Python',
        name5: 'Java',
        name6:'C#',
        percent1: 90,
        percent2: 90,
        percent3: 70,
        percent4: 70,
        percent5: 10,
        percent6: 10,
    },
    {
        id: 3,
        type: 'tools',
        name1: 'Git',
        name2: 'npm',
        name3: 'Chrome Dev Tool',
        name4: 'Firebase',
        name5: 'Heroku',
        name6: 'Netlify',
        name7: 'vs code',
        name8: 'codeBlocks',
        name9: 'pyCharm',
        percent1: 90,
        percent2: 90,
        percent3: 60,
        percent4: 70,
        percent5: 70,
        percent6: 70,
        percent7: 85,
        percent8: 85,
        percent9: 80,
    }

]
export default SkillsInfo;